// Smooth-scroll the window back to the top of the page. Used by every
// full page table's prev and next pagination handlers so the user is not
// left at the bottom of the previous page after moving to the next one.
export const scrollToPageTop = () => {
    if (typeof window === 'undefined') return;
    window.scrollTo({ top: 0, behavior: 'smooth' });
};
